import { Space } from 'antd';
import { FormattedMessage } from 'react-intl';

import { api } from '@/api';
import { DeleteAction, EditAction } from '@/components/table/actions';
import { getColumnSearchFields } from '@/components/table/filters';
import { PERMISSION_DELETE, PERMISSION_OBJ_CAMPAIGN, PERMISSION_UPDATE } from '@/constants/permissions';
import { withPermissions } from '@/hocs/permission';
import { campaignStore } from '@/stores';
import { showError } from '@/utils/common';

const PermissionedEditAction = withPermissions([[PERMISSION_OBJ_CAMPAIGN, PERMISSION_UPDATE]])(EditAction);
const PermissionedDeleteAction = withPermissions([[PERMISSION_OBJ_CAMPAIGN, PERMISSION_DELETE]])(DeleteAction);

const Actions = (_: any, record: any) => {
  const onDelete = () => {
    api.campaigns
      .delete(record.id)
      .source.then(() => campaignStore.deleteItem(record.id))
      .catch(showError);
  };

  return (
    <Space>
      <PermissionedEditAction uiSref={{ to: 'base-layout.campaigns.edit', params: { campaignId: record.id } }} />
      <PermissionedDeleteAction onConfirm={onDelete} />
    </Space>
  );
};

export const columns = [
  {
    title: 'id',
    dataIndex: 'id',
    sorter: true,
  },
  {
    title: <FormattedMessage id="campaigns.name" />,
    dataIndex: 'name',
    ...getColumnSearchFields(),
  },
  {
    title: <FormattedMessage id="campaigns.year" />,
    dataIndex: 'year',
    sorter: true,
  },
  {
    title: '',
    render: Actions,
    className: 'actions',
  },
];
